import {useEffect, useState} from "react";
import {isStringUndefinedOrBlank} from "@ots-frontend/ots-data";
import {DataTableColumn} from "mantine-datatable";
import {DataTableTextFilter} from "../filter/DataTableTextFilter/DataTableTextFilter";

export type UseDataTableFilterProps<T> = {
  records: T[]
  filterConfig: DataTableFilterConfig<T>
}

export type UseDataTableFilterResult<T> = {
  filteredRecords: T[]
  filterConfig: DataTableFilterConfig<T>
}

export type DataTableFilterConfig<T> = {
  [key: string]: {
    debouncedQuery: string | undefined
    setQuery: (query: string | undefined) => void
    query: string | undefined
    filter: (record: T, query: string) => boolean
  }
}

export function useDataTableFilter<T>(props: UseDataTableFilterProps<T>): UseDataTableFilterResult<T> {
  const {records, filterConfig} = props;

  const [filteredRecords, setFilteredRecords] = useState<T[]>([]);

  useEffect(() => {
    console.log("filtering")
    setFilteredRecords(
      records.filter((record) => {
        for (const fieldFilterConfig of Object.values(filterConfig)) {
          const query = fieldFilterConfig.debouncedQuery
          if (query) {
            if (!isStringUndefinedOrBlank(query) && fieldFilterConfig.filter(record, query)) {
              return false
            }
          }
        }
        return true;
      })
    );
  }, [records, filterConfig]);

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig,
  };
}

export function getColumnFilterProps<T>(config: DataTableFilterConfig<T> | undefined, key: string): Pick<DataTableColumn<T>, 'filtering' | 'filter'> {
  if (config) {
    if (key in config) {
      const keyConfig = config[key]
      return {
        filtering: typeof keyConfig.debouncedQuery !== 'undefined',
        filter: (
          <DataTableTextFilter
            setQuery={keyConfig.setQuery}
            query={keyConfig.query}/>
        ),
      }
    }
  }

  return {}
}
